import { useContext } from 'react';
import { AppContext } from '../App';
import { AppContext as MainAppContext } from '../../App';
import logo_wide from '../assets/logo_wide.png';


export default function CorePaper(props) {

  const app = useContext(AppContext);
  const mainApp = useContext(MainAppContext);

  function clicked(e) {
    e.stopPropagation();
  }

  if(app.gameData) {
    if(app.gameData.status !== 'ongoing') {
      return (
        <div className='CorePaper coreShadow' onClick={clicked}>
          <div className='text-center'>
            <img src={logo_wide} style={{ width: "80%", height: "auto", marginBottom: "20px" }}/>
    
            {
              (app.gameData.status === 'hosted') ?
              <>
                <h5 style={{ fontSize: "30px" }}>Game Hosted</h5>
                <h6 style={{ marginTop: "20px", fontSize: "14px" }} className='font-light'>Waiting for opponent to join</h6>
              </>
              :""
            }

            {
              (app.gameData.status === 'superdraw') ?
              <>
                <h5 style={{ fontSize: "30px" }}>Game Draw</h5>
                <h6 style={{ marginTop: "20px", fontSize: "14px" }} className='font-light'>Players reached {app.gameData.drawsNumber} draws</h6>
              </>
              :""
            }

            {
              (app.gameData.status === 'completed') ?
              <>
                <h5 style={{ fontSize: "30px" }}>Game Over</h5>
                <h6 style={{ fontSize: "25px", marginTop: "20px", textTransform: "uppercase", color: "var(--core-goldish)" }} className='font-light'>{app.gameData.winnerInfo.username} Won!</h6>
                <h6 style={{ marginTop: "20px", fontSize: "14px" }} className='font-light'>{app.gameData.completionReason}</h6>
              </>
              :""
            }
    
            <div className='row' style={{ marginTop: "30px" }}>
              <div className='col-4 text-start'>
                <button
                 className='btn'
                 style={{
                  background: "var(--core-blackish)",
                  color: "var(--core-whitish)",
                 }}
                 onClick={mainApp.navBack}
                >
                  Back
                </button>
              </div>

              <div className='col-4 text-center'>
                {
                  (app.gameData.status !== 'hosted') ?
                  <button
                    className='btn'
                    style={{
                      background: "var(--core-blackish)",
                      color: "var(--core-whitish)",
                    }}
                    onClick={app.triggerChat}
                  >
                    Chat
                  </button>: ""
                }
              </div>

              <div className='col-4 text-end'>
                <button
                 className='btn'
                 style={{
                  background: "var(--core-blackish)",
                  color: "var(--core-whitish)",
                 }}
                 onClick={mainApp.navHome}
                >
                  Home
                </button>
              </div>
            </div>
          </div>
        </div>
      )
    }
  }
}